<template>
    <ModalRouteChild small :parent="parent">
        <SectionTitle
            :title="config.COMPLETE_TITLE"
            :description="config.COMPLETE_DESCRIPTION"
        />
        <SectionPicture>
            <ArtComplete :color="config.COLOR_PRIMARY"/>
        </SectionPicture>
        <SectionText :text="config.COMPLETE_SHARE"/>
        <section class="social">
            <img class="network" src="~@skeepers/platform-framework/assets/img/facebook.svg" @click="onShareFacebook"/>
            <img class="network" src="~@skeepers/platform-framework/assets/img/twitter.svg" @click="onShareTwitter"/>
        </section>
    </ModalRouteChild>
</template>
<script>
import { ModalRouteChild } from '@skeepers/platform-framework/components/desktop';
import { SocialConsumer, SolutionConsumer, TrackingConsumer } from '@skeepers/platform-framework/mixins';
import { SectionTitle, SectionPicture, SectionText } from '@skeepers/platform-framework/components/shared';

import { ArtComplete } from '@/components/svg';

export default {
    name: 'CompleteModal',
    components: {
        ModalRouteChild, ArtComplete, SectionTitle, SectionPicture, SectionText,
    },
    mixins: [SocialConsumer, SolutionConsumer, TrackingConsumer],
    props: {
        parent: {
            type: String,
            default: 'deposit',
        },
    },
    methods: {
        onShareFacebook () {
            this.trackEvent('CASTING_SHARE');
            this.shareFacebook(this.shareUrl.href);
        },
        onShareTwitter () {
            this.trackEvent('CASTING_SHARE');
            this.shareTwitter(this.shareUrl.href);
        },
    },
};
</script>
<style lang="scss" scoped>
@import '~@skeepers/platform-framework/assets/scss/mixins';

section {
    &.social {
        text-align: center;

        > .network {
            @include square(32px);
            cursor: pointer;

            &:first-of-type {
                margin-right: 16px;
            }

        }
    }
}
</style>
